export default __webpack_public_path__ + "static/media/job-board-page.8898ffaf.png";